export default __webpack_public_path__ + "static/media/warning.d1b10045.png";